/* eslint-disable */

import ApiModel from '../base/ApiModel'

class Selection extends ApiModel {

  constructor(data = null) {
    super(data)

    this.id = ''
    this.pollable_id = ''
    this.pollable_type = ''
    this.option_id = ''

    if (data !== null) {
      this.populate(data)
    }
  }

  static get className() {
    return 'Selection';
  }

}

export default Selection
